module.exports = __webpack_public_path__ + "officialStatic/img/product-rlmj.bcb290a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-rlmj.png
// module id = cLQX
// module chunks = 0